import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Stories API
export const getStories = async (category = null) => {
  try {
    const url = category ? `${API}/stories?category=${category}` : `${API}/stories`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching stories:', error);
    throw error;
  }
};

export const getStoryById = async (storyId) => {
  try {
    const response = await axios.get(`${API}/stories/${storyId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching story:', error);
    throw error;
  }
};

export const createStory = async (storyData) => {
  try {
    const response = await axios.post(`${API}/stories`, storyData);
    return response.data;
  } catch (error) {
    console.error('Error creating story:', error);
    throw error;
  }
};

export const updateStory = async (storyId, storyData) => {
  try {
    const response = await axios.put(`${API}/stories/${storyId}`, storyData);
    return response.data;
  } catch (error) {
    console.error('Error updating story:', error);
    throw error;
  }
};

export const deleteStory = async (storyId) => {
  try {
    const response = await axios.delete(`${API}/stories/${storyId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting story:', error);
    throw error;
  }
};

// Contact API
export const submitContact = async (contactData) => {
  try {
    const response = await axios.post(`${API}/contact`, contactData);
    return response.data;
  } catch (error) {
    console.error('Error submitting contact form:', error);
    throw error;
  }
};

export const getContacts = async () => {
  try {
    const response = await axios.get(`${API}/contact`);
    return response.data;
  } catch (error) {
    console.error('Error fetching contacts:', error);
    throw error;
  }
};

// Author API
export const getAuthor = async () => {
  try {
    const response = await axios.get(`${API}/author`);
    return response.data;
  } catch (error) {
    console.error('Error fetching author info:', error);
    throw error;
  }
};

export const updateAuthor = async (authorData) => {
  try {
    const response = await axios.put(`${API}/author`, authorData);
    return response.data;
  } catch (error) {
    console.error('Error updating author info:', error);
    throw error;
  }
};

// Novels API
export const getNovels = async () => {
  try {
    const response = await axios.get(`${API}/novels`);
    return response.data;
  } catch (error) {
    console.error('Error fetching novels:', error);
    throw error;
  }
};

export const getNovelById = async (novelId) => {
  try {
    const response = await axios.get(`${API}/novels/${novelId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching novel:', error);
    throw error;
  }
};

export const createNovel = async (novelData) => {
  try {
    const response = await axios.post(`${API}/novels`, novelData);
    return response.data;
  } catch (error) {
    console.error('Error creating novel:', error);
    throw error;
  }
};

export const updateNovel = async (novelId, novelData) => {
  try {
    const response = await axios.put(`${API}/novels/${novelId}`, novelData);
    return response.data;
  } catch (error) {
    console.error('Error updating novel:', error);
    throw error;
  }
};

export const deleteNovel = async (novelId) => {
  try {
    const response = await axios.delete(`${API}/novels/${novelId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting novel:', error);
    throw error;
  }
};

// Chapters API
export const getChaptersByNovel = async (novelId) => {
  try {
    const response = await axios.get(`${API}/chapters/novel/${novelId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching chapters:', error);
    throw error;
  }
};

export const getChapterById = async (chapterId) => {
  try {
    const response = await axios.get(`${API}/chapters/${chapterId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching chapter:', error);
    throw error;
  }
};

export const createChapter = async (chapterData) => {
  try {
    const response = await axios.post(`${API}/chapters`, chapterData);
    return response.data;
  } catch (error) {
    console.error('Error creating chapter:', error);
    throw error;
  }
};

export const updateChapter = async (chapterId, chapterData) => {
  try {
    const response = await axios.put(`${API}/chapters/${chapterId}`, chapterData);
    return response.data;
  } catch (error) {
    console.error('Error updating chapter:', error);
    throw error;
  }
};

export const deleteChapter = async (chapterId) => {
  try {
    const response = await axios.delete(`${API}/chapters/${chapterId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting chapter:', error);
    throw error;
  }
};
